/* Copyright 2016 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

"use strict";

import { decode } from "base64-arraybuffer";

if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("CHROME")) {
  var defaultUrl; // eslint-disable-line no-var

  (function rewriteUrlClosure() {
    // Run this code outside DOMContentLoaded to make sure that the URL
    // is rewritten as soon as possible.
    const queryString = document.location.search.slice(1);
    const m = /(^|&)file=([^&]*)/.exec(queryString);
    defaultUrl = m ? decodeURIComponent(m[2]) : "";

    // Example: chrome-extension://.../http://example.com/file.pdf
    const humanReadableUrl = "/" + defaultUrl + location.hash;
    history.replaceState(history.state, "", humanReadableUrl);
    if (top === window) {
      // eslint-disable-next-line no-undef
      chrome.runtime.sendMessage("showPageAction");
    }
  })();
}

let pdfjsWebApp, pdfjsWebAppOptions;
if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("PRODUCTION")) {
  pdfjsWebApp = require("./app.js");
  pdfjsWebAppOptions = require("./app_options.js");
}

if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("MOZCENTRAL")) {
  require("./firefoxcom.js");
  require("./firefox_print_service.js");
}
if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("GENERIC")) {
  require("./genericcom.js");
}
if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("CHROME")) {
  require("./chromecom.js");
}
if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("CHROME || GENERIC")) {
  require("./pdf_print_service.js");
}

function getViewerConfiguration() {
  return {
    appContainer: document.body,
    mainContainer: document.getElementById("viewerContainer"),
    viewerContainer: document.getElementById("viewer"),
    eventBus: null,
    toolbar: {
      container: document.getElementById("toolbarViewer"),
      numPages: document.getElementById("numPages"),
      pageNumber: document.getElementById("pageNumber"),
      scaleSelectContainer: document.getElementById("scaleSelectContainer"),
      scaleSelect: document.getElementById("scaleSelect"),
      customScaleOption: document.getElementById("customScaleOption"),
      previous: document.getElementById("previous"),
      next: document.getElementById("next"),
      zoomIn: document.getElementById("zoomIn"),
      zoomOut: document.getElementById("zoomOut"),
      viewFind: document.getElementById("viewFind"),
      openFile: document.getElementById("openFile"),
      print: document.getElementById("print"),
      presentationModeButton: document.getElementById("presentationMode"),
      download: document.getElementById("download"),
      viewBookmark: document.getElementById("viewBookmark"),
    },
    secondaryToolbar: {
      toolbar: document.getElementById("secondaryToolbar"),
      toggleButton: document.getElementById("secondaryToolbarToggle"),
      toolbarButtonContainer: document.getElementById(
        "secondaryToolbarButtonContainer"
      ),
      presentationModeButton: document.getElementById(
        "secondaryPresentationMode"
      ),
      openFileButton: document.getElementById("secondaryOpenFile"),
      printButton: document.getElementById("secondaryPrint"),
      downloadButton: document.getElementById("secondaryDownload"),
      viewBookmarkButton: document.getElementById("secondaryViewBookmark"),
      firstPageButton: document.getElementById("firstPage"),
      lastPageButton: document.getElementById("lastPage"),
      pageRotateCwButton: document.getElementById("pageRotateCw"),
      pageRotateCcwButton: document.getElementById("pageRotateCcw"),
      cursorSelectToolButton: document.getElementById("cursorSelectTool"),
      cursorHandToolButton: document.getElementById("cursorHandTool"),
      scrollVerticalButton: document.getElementById("scrollVertical"),
      scrollHorizontalButton: document.getElementById("scrollHorizontal"),
      scrollWrappedButton: document.getElementById("scrollWrapped"),
      spreadNoneButton: document.getElementById("spreadNone"),
      spreadOddButton: document.getElementById("spreadOdd"),
      spreadEvenButton: document.getElementById("spreadEven"),
      documentPropertiesButton: document.getElementById("documentProperties"),
    },
    fullscreen: {
      contextFirstPage: document.getElementById("contextFirstPage"),
      contextLastPage: document.getElementById("contextLastPage"),
      contextPageRotateCw: document.getElementById("contextPageRotateCw"),
      contextPageRotateCcw: document.getElementById("contextPageRotateCcw"),
    },
    sidebar: {
      // Divs (and sidebar button)
      outerContainer: document.getElementById("outerContainer"),
      viewerContainer: document.getElementById("viewerContainer"),
      toggleButton: document.getElementById("sidebarToggle"),
      // Buttons
      thumbnailButton: document.getElementById("viewThumbnail"),
      outlineButton: document.getElementById("viewOutline"),
      attachmentsButton: document.getElementById("viewAttachments"),
      layersButton: document.getElementById("viewLayers"),
      // Views
      thumbnailView: document.getElementById("thumbnailView"),
      outlineView: document.getElementById("outlineView"),
      attachmentsView: document.getElementById("attachmentsView"),
      layersView: document.getElementById("layersView"),
    },
    sidebarResizer: {
      outerContainer: document.getElementById("outerContainer"),
      resizer: document.getElementById("sidebarResizer"),
    },
    findBar: {
      bar: document.getElementById("findbar"),
      toggleButton: document.getElementById("viewFind"),
      findField: document.getElementById("findInput"),
      highlightAllCheckbox: document.getElementById("findHighlightAll"),
      caseSensitiveCheckbox: document.getElementById("findMatchCase"),
      entireWordCheckbox: document.getElementById("findEntireWord"),
      findMsg: document.getElementById("findMsg"),
      findResultsCount: document.getElementById("findResultsCount"),
      findPreviousButton: document.getElementById("findPrevious"),
      findNextButton: document.getElementById("findNext"),
    },
    passwordOverlay: {
      overlayName: "passwordOverlay",
      container: document.getElementById("passwordOverlay"),
      label: document.getElementById("passwordText"),
      input: document.getElementById("password"),
      submitButton: document.getElementById("passwordSubmit"),
      cancelButton: document.getElementById("passwordCancel"),
    },
    documentProperties: {
      overlayName: "documentPropertiesOverlay",
      container: document.getElementById("documentPropertiesOverlay"),
      closeButton: document.getElementById("documentPropertiesClose"),
      fields: {
        fileName: document.getElementById("fileNameField"),
        fileSize: document.getElementById("fileSizeField"),
        title: document.getElementById("titleField"),
        author: document.getElementById("authorField"),
        subject: document.getElementById("subjectField"),
        keywords: document.getElementById("keywordsField"),
        creationDate: document.getElementById("creationDateField"),
        modificationDate: document.getElementById("modificationDateField"),
        creator: document.getElementById("creatorField"),
        producer: document.getElementById("producerField"),
        version: document.getElementById("versionField"),
        pageCount: document.getElementById("pageCountField"),
        pageSize: document.getElementById("pageSizeField"),
        linearized: document.getElementById("linearizedField"),
      },
    },
    errorWrapper: {
      container: document.getElementById("errorWrapper"),
      errorMessage: document.getElementById("errorMessage"),
      closeButton: document.getElementById("errorClose"),
      errorMoreInfo: document.getElementById("errorMoreInfo"),
      moreInfoButton: document.getElementById("errorShowMore"),
      lessInfoButton: document.getElementById("errorShowLess"),
    },
    printContainer: document.getElementById("printContainer"),
    openFileInputName: "fileInput",
    debuggerScriptPath: "./debugger.js",
  };
}

function webViewerLoad() {
  document.body.classList.add("pdfIsLoading");
  const config = getViewerConfiguration();
  if (typeof PDFJSDev === "undefined" || !PDFJSDev.test("PRODUCTION")) {
    Promise.all([
      import("pdfjs-web/app.js"),
      import("pdfjs-web/app_options.js"),
      import("pdfjs-web/genericcom.js"),
      import("pdfjs-web/pdf_print_service.js"),
    ]).then(function ([app, appOptions, genericCom, pdfPrintService]) {
      window.PDFViewerApplication = app.PDFViewerApplication;
      window.PDFViewerApplicationOptions = appOptions.AppOptions;
      app.PDFViewerApplication.run(config);
    });
  } else {
    if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("CHROME")) {
      pdfjsWebAppOptions.AppOptions.set("defaultUrl", defaultUrl);
    }

    window.PDFViewerApplication = pdfjsWebApp.PDFViewerApplication;
    window.PDFViewerApplicationOptions = pdfjsWebAppOptions.AppOptions;

    if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("GENERIC")) {
      // Give custom implementations of the default viewer a simpler way to
      // set various `AppOptions`, by dispatching an event once all viewer
      // files are loaded but *before* the viewer initialization has run.
      const event = document.createEvent("CustomEvent");
      event.initCustomEvent("webviewerloaded", true, true, {
        source: window,
      });
      try {
        // Attempt to dispatch the event at the embedding `document`,
        // in order to support cases where the viewer is embedded in
        // a *dynamically* created <iframe> element.
        parent.document.dispatchEvent(event);
      } catch (ex) {
        // The viewer could be in e.g. a cross-origin <iframe> element,
        // fallback to dispatching the event at the current `document`.
        console.error(`webviewerloaded: ${ex}`);
        document.dispatchEvent(event);
      }
    }

    pdfjsWebApp.PDFViewerApplication.run(config);
  }
}

if (
  document.readyState === "interactive" ||
  document.readyState === "complete"
) {
  // webViewerLoad();
} else {
  // document.addEventListener("DOMContentLoaded", webViewerLoad, true);
}

/* custom */
(function () {
  const trackStartTime = Date.now();
  /** 心跳包采集时间间隔 10s */
  const trackInterval = 10000;
  const trackIntervalId = null;

  /** 图形验证码 id（是个固定值，由后端提供） */
  const CaptchaAppId = "199959384";
  /** 是否线上环境 */
  const isProduction = window.location.host === "research.tencent.com";

  const search = window.location.search.substring(1);
  /**
   * 链接中携带的参数
   * - from： h5/weapp 用于判断来源（在电脑端的小程序中，在线阅读可能会跳转到当前页面）
   * - token：小程序鉴权使用的 token （只有 api/researchreport/researchreports/${reportId}/preview 接口有效使用有效）
   * - r/id： 当前报告的 id
   * - permissionticket: 小程序权限 ticket， web 可直接通过 fetchAuthTicket 获取
   */
  const params = parseQueryString(search);

  /** 是否小程序 */
  const IS_WEAPP = params.from === "weapp";
  /** 小程序的 token */
  const WEAPP_TOKEN = params.token;

  /** 当前报告 id */
  const reportHashId = params.id ? params.id : params.r;

  window.urcloud = {};
  window.urcloud.params = params;

  /** 接口返回的状态 */
  const APIResponseCode = {
    /** 接口请求成功 */
    Success: 0,
    /** 请求报告权限票据接口：报告设置了留资查看但还没有填写资料 */
    TicketNeedUserInfo: 100415,
  };

  /**
   * 权限票据
   * - 小程序直接从链接参数中获取
   * - web 通过 fetchAuthTicket 接口获取
   */
  let PERMISSION_TICKET = params.permissionticket;

  /**
   * 节流
   */
  function throttle(fn, interval) {
    let last = 0;
    return function (...args) {
      const context = this;
      let now = new Date();
      if (now - last < interval) return;
      fn.apply(context, args);
      last = now;
    };
  }

  function getVisibilityState() {
    // 如果hidden 属性是原生支持的，我们就直接返回
    if ("hidden" in document) {
      return "hidden";
    }

    const prefixes = ["webkit", "moz", "ms", "o"];
    let hidden = null;

    // 其他的情况就循环现有的浏览器前缀，拼接我们所需要的属性
    prefixes.forEach(prefix => {
      if (`${prefix}Hidden` in document) {
        hidden = `${prefix}Hidden`;
      }
    });
    return hidden;
  }

  /**
   * 初始化 horizon 前端埋点
   */
  function setupHorizon() {
    // 保存对应script标签的id值，登录成功后通过该id值获取当前script标签设置data-user-id属性值
    window.horizonTrackerScriptId = "horizon-tracker";
    const _horizon = {};
    (function () {
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.id = window.horizonTrackerScriptId;
      s.setAttribute(
        "data-account",
        `research.tencent.com.${isProduction ? "production" : "test"}`
      );
      s.setAttribute("data-user-id", "");
      s.src = "https://horizon-assets.qq.com/analytics.js";
      document.body.appendChild(s);
      window._horizon = _horizon;
    })();
  }

  /**
   * 发送埋点数据
   * @param  {...any} args
   */
  function horizonSend(...args) {
    if (window._horizon && typeof window._horizon.send === "function") {
      window._horizon.send(...args);
    }
  }

  /**
   * 心跳包统计阅读时长
   */
  function horizonTime() {
    return setInterval(() => {
      /**
       * eventCategory __report_detail_view_time__
       * eventAction 报告id
       * eventLabel 统计间隔
       * eventValue 开始时间（可以根据开始时间判断是否同一次阅读）
       */
      horizonSend(
        "__report_detail_view_time__",
        reportHashId,
        trackInterval,
        trackStartTime
      );
    }, trackInterval);
  }

  /**
   * 启动阅读时长统计
   */
  function setupHorizonTime() {
    horizonTime();
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === getVisibilityState()) {
        // 当页面处于隐藏状态时取消定时器
        clearInterval(trackIntervalId);
      } else {
        // 当页面处于可视状态时开启定时器
        trackIntervalId = horizonTime();
      }
    });
  }

  /**
   * 统计阅读进度
   * @param {*} percent 阅读进度
   * @param {*} contentHeight 报告内容高度
   * @param {*} clientHeight 浏览器可视区域高度
   */
  function horizonPercent(percent, contentHeight, clientHeight) {
    /**
     * eventCategory __report_detail_view_percent__
     * eventAction 报告id
     * eventLabel 阅读进度
     * eventValue 开始时间（可以根据开始时间判断是否同一次阅读）
     */
    horizonSend(
      "__report_detail_view_percent__",
      reportHashId,
      percent,
      JSON.stringify({
        startTime: trackStartTime, // 开始时间（可以根据开始时间判断是否同一次阅读）
        clientHeight, // 浏览器可视区域高度
        contentHeight, // 报告内容高度
      })
    );
  }

  /**
   * 启动阅读进度统计
   * @param {*} options
   */
  function setupHorizonPercent() {
    // 可视区域高度( +50 避免有时候即使滚动到底也没有到达100% )
    const clientHeight = document.documentElement.clientHeight + 50;

    // 滚动过程中发送进度（节流）
    const throttleHorizon = throttle(horizonPercent, 2000);
    // 计算阅读进度百分比
    const getPercent = (scrollTop, contentHeight) => {
      return Math.min((clientHeight + scrollTop) / contentHeight, 1) * 100;
    };
    // 获取内容高度
    const getContentHeight = () => {
      const viewerEle = document.getElementById("viewer");
      const contentHeight = (viewerEle ? viewerEle.clientHeight : 0) + 10;
      return contentHeight;
    };

    const viewerContainer = document.getElementById("viewerContainer");
    viewerContainer.addEventListener("scroll", e => {
      const contentHeight = getContentHeight();
      const percent = getPercent(e.target.scrollTop, contentHeight);
      if (percent < 100) {
        throttleHorizon(percent, contentHeight, clientHeight);
      } else {
        horizonPercent(100, contentHeight, clientHeight);
      }
    });

    // 发送初始的阅读进度，当一屏可以显示完整的报告时，默认阅读进度为100%
    setTimeout(() => {
      // 报告的总高度
      const contentHeight = getContentHeight();
      const percent = getPercent(0, contentHeight);

      horizonPercent(percent, contentHeight, clientHeight);
    }, 500);
  }

  /**
   * 接口请求
   * @param {Object} options
   * @param {String} options.url 具体请求的接口
   * @returns
   */
  function request(options) {
    return new Promise((resolve, reject) => {
      const xhr = window.XMLHttpRequest
        ? new XMLHttpRequest()
        : new ActiveXObject("Microsoft.XMLHTTP");

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          const status = xhr.status;
          if (status >= 200 && status < 300) {
            const data = JSON.parse(xhr.responseText);
            if (data.code === APIResponseCode.Success) {
              resolve(data);
            } else {
              reject(data);
            }
          } else {
            reject({
              code: status,
              message: "访问出错了",
            });
          }
        }
      };

      xhr.open("GET", options.url, true);
      xhr.send(null);
    });
  }

  function resolveApi(url) {
    const apiBasename = window.urcloud.params.a || "/";
    return apiBasename + url;
  }

  function parseQueryString(query) {
    const parts = query.split("&");
    const params = Object.create(null);
    for (let i = 0, ii = parts.length; i < ii; ++i) {
      const param = parts[i].split("=");
      const key = param[0].toLowerCase();
      const value = param.length > 1 ? param[1] : null;
      params[decodeURIComponent(key)] = decodeURIComponent(value);
    }
    return params;
  }

  function onError(msg) {
    const outerContainer = document.querySelector("#outerContainer");
    const errorWrap = document.querySelector(".error-wrap");
    const errorMsg = document.querySelector("#errorMsg");

    outerContainer.style.display = "none";
    errorWrap.style.display = "flex";
    errorMsg.innerHTML = msg;

    // 移除 loading 态
    document.body.classList.remove("pdfIsLoading");
  }

  /**
   * 未登录的情况下跳转到登录页面
   */
  function redirectToLoginPage() {
    // 登录成功后回跳到当前页面
    const redirectUrl = encodeURIComponent(location.href);
    // 登录页面地址
    const loginPageUrl = `/login?s_url=${redirectUrl}`;

    window.location.href = loginPageUrl;
  }

  /**
   * 获取报告详情数据
   * @param {object} params
   * @param {string} params.captchaRandstr 防水墙验证码返回的随机字符串
   * @param {string} params.captchaTicket  防水墙验证码返回的ticket
   */
  function fetchReportPreviewData(params) {
    const { captchaRandstr, captchaTicket } = params || {};

    let preViewUrl = `api/researchreport/researchreports/${reportHashId}/preview?permissionTicket=${encodeURIComponent(
      PERMISSION_TICKET
    )}`;

    // 小程序没有图形验证码
    if (WEAPP_TOKEN) {
      preViewUrl = `${preViewUrl}&token=${encodeURIComponent(WEAPP_TOKEN)}`;
    } else {
      preViewUrl = `${preViewUrl}&randomString=${captchaRandstr}&ticket=${captchaTicket}`;
    }

    request({ url: resolveApi(preViewUrl) })
      .then(fileData => {
        // base64 转成 binary
        const base64Data = fileData.data;
        const arraybufferData = decode(base64Data);
        window.urcloud.file = arraybufferData;
        webViewerLoad();

        /** ====== 启动阅读时长统计 ====== */
        setupHorizonTime();

        /** ====== 启动阅读进度统计 ====== */
        setupHorizonPercent();
      })
      .catch(e => {
        onError(e.message || "文件转换出错");
      });
  }

  /**
   * 防水墙图形验证码操作后的回调
   *  @param res 结果
   *    res.ret           验证结果，0：验证成功。2：用户主动关闭验证码。
   *    res.ticket        验证成功的票据，当且仅当 ret = 0 时 ticket 有值
   *    res.randstr       本次验证的随机串，后续票据校验时需传递该参数
   */
  function captchaCallback(res) {
    // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
    if (res.ret === 0) {
      // 获取报告的详情数据
      fetchReportPreviewData({
        captchaRandstr: res.randstr,
        captchaTicket: res.ticket,
      });
    }
  }

  /**
   * 防水墙图形验证码：https://cloud.tencent.com/document/product/1110/36841
   */
  function initCaptcha() {
    try {
      //生成一个验证码对象
      const captcha = new TencentCaptcha(CaptchaAppId, captchaCallback, {
        enableAged: true,
      });

      // 调用方法，显示验证码
      captcha.show();
    } catch (error) {
      // 防水墙图形验证码加载错误处理
      const ticket =
        "terror_1001_" + CaptchaAppId + Math.floor(new Date().getTime() / 1000);
      captchaCallback({
        ret: 0,
        randstr: "@" + Math.random().toString(36).substr(2),
        ticket: ticket,
        errorCode: 1001,
        errorMessage: "jsload_error",
      });
    }
  }

  /**
   * 获取报告的基础信息，判断是否有权限查阅
   */
  function fetchReportInfo() {
    if (reportHashId) {
      request({
        url: resolveApi(`api/researchreport/researchreports/${reportHashId}`),
      })
        .then(data => {
          if (data.hashId) {
            document.title = `${
              data.title ? data.title + " - " : ""
            }腾讯调研云`;

            if (!data.permissions.preview) {
              onError("您没有该报告的阅读权限");
            } else {
              window.urcloud.report = data;

              // 有权限查看，显示防水墙验证码
              initCaptcha();
            }
          }
        })
        .catch(e => {
          onError(e.message || "访问出错了");
        });
    }
  }

  /**
   * 获取用户信息
   */
  function fetchUserInfo() {
    // 显示 loading 态
    document.body.classList.add("pdfIsLoading");
    request({ url: resolveApi("api/user/v2/RESEARCH/info") })
      .then(data => {
        // 记录用户信息
        window.urcloud.currentUser = data.user;

        // 设置埋点
        const horizonTrackerScript = document.getElementById(
          window.horizonTrackerScriptId
        );
        if (data.user.guid && horizonTrackerScript) {
          // 设置horizon的data-user-id
          horizonTrackerScript.setAttribute("data-user-id", data.user.guid);
        }

        // 埋点
        horizonSend("阅读全文页", "打开页面", reportHashId);

        // 获取票据
        fetchAuthTicket().then(() => {
          // 权限校验通过,请求报告信息
          fetchReportInfo();
        });
      })
      .catch(() => {
        // 未获取到用户信息跳转到登录页面
        redirectToLoginPage();
      });
  }

  /**
   * 根据报告 id 获取报告的权限票据
   * 可以根据接口返回的不同的状态码判断对应的权限
   * eg: 接口返回的状态码为 100415 时,表示报告开启了留字查阅,但是当前用户还没有填写资料
   * 接口文档: http://cdc-micro.woa.com/openapi/docs#tag/ResearchReport/operation/ResearchReport_SetRequiredFieldsForContent
   */
  function fetchAuthTicket() {
    return request({
      url: resolveApi(
        `api/researchreport/${reportHashId}/info/collection/ticket`
      ),
    })
      .then(res => {
        // 记录权限票据
        PERMISSION_TICKET = res.ticket;
      })
      .catch(err => {
        if (err.code === APIResponseCode.TicketNeedUserInfo) {
          // 需要填写资料,跳转到报告概览页并自动打开资料填写弹窗
          location.href = `/report?id=${reportHashId}&autoOpen=user-info-collection`;
        }

        onError(err.message);
      });
  }

  /**
   * 启动 pdf 在线阅读数据
   */
  function initPdf() {
    /**
     * 小程序在线阅读数据请求流程，小程序直接使用 token 鉴权
     *
     * token 仅对接口 `api/researchreport/researchreports/${reportHashId}/preview` 生效，所以直接请求报告 pdf 数据
     *
     * 小程序在线阅读数据请求流程
     * 1. 判断是否已经登录（小程序通过 token 鉴权，有 token 相当于已经登录）
     * 2. 请求报告详情数据 fetchReportPreviewData （小程序不显示图形验证码）
     *
     */
    if (IS_WEAPP && WEAPP_TOKEN) {
      fetchReportPreviewData();

      return;
    }

    /**
     * pc 在线阅读数据请求流程
     *
     * 1. 先判断是否已经登录 fetchUserInfo，未登录跳转到登录页面
     * 2. 判断当前是否有权限 fetchAuthTicket 根据不同的权限状态码处理权限 eg: 报告设置了留资时是否已经填写了资料
     * 3. 请求报告的基础信息 fetchReportInfo 判断是否有查看权限
     * 4. 显示防水墙验证码   initCaptcha
     * 5. 验证码通过后请求报告详情数据 fetchReportPreviewData
     */

    //  初始化防水墙验证码图形：https://cloud.tencent.com/document/product/1110/36841
    const script = document.createElement("script");
    script.src = "https://turing.captcha.qcloud.com/TCaptcha.js";
    script.onload = () => {
      // 判断用户是否登录
      fetchUserInfo();
    };

    document.body.appendChild(script);
  }

  document.addEventListener("DOMContentLoaded", function () {
    /** 启动埋点 */
    setupHorizon();

    /** 加载 pdf 数据 */
    initPdf();
  });
})();
